import React from 'react';
import { ReactComponent as DepartmentSale } from '../media/DepartmentSale.svg';
import { ReactComponent as MergeTransaction } from '../media/MergeTransaction.svg';
import { ReactComponent as PersonRemove } from '../media/PersonRemove.svg';
// import { ReactComponent as ChangeEligibility } from '../media/ChangeEligibility.svg';
import { ReactComponent as PriceOverride } from '../media/PriceOverride.svg';
import { ReactComponent as Repeat } from '../media/Repeat.svg';
import { ReactComponent as SaveTransaction } from '../media/SaveTransaction.svg';
import { ReactComponent as ScanAndGo } from '../media/ScanAndGo.svg';
import { ReactComponent as Print } from '../../common/media/print.svg';
// import { ReactComponent as TareWeight } from '../media/TareWeight.svg';
import { ReactComponent as VoidCode } from '../media/VoidCode.svg';
import { ReactComponent as VoidItem } from '../media/VoidItem.svg';
import { ReactComponent as VoidLine } from '../media/VoidLine.svg';
import { ReactComponent as ReturnItem } from '../media/return-item.svg';
import { ReactComponent as PriceCheck } from '../media/PriceCheckIcon.svg';
import { ReactComponent as TaxExemption } from '../media/TaxExemption.svg';
import { ReactComponent as ReloadItem } from '../media/reload-item.svg';
import { ReactComponent as Voucher } from '../media/VoucherCommand.svg';
import { ReactComponent as Cash } from '../media/Cash.svg';
import { ReactComponent as TenderExchange } from '../media/TenderExchange.svg';
import { ReactComponent as OnlineItemBalanceInquiry } from '../media/BalanceInquiry.svg';
import { ReactComponent as SaleMode } from '../media/SaleMode.svg';
import { ReactComponent as DepartmentReturn } from '../media/DepartmentReturn.svg';
import { ReactComponent as OwnBag } from '../media/OwnBag.svg';

// this will be implemented either when needed again or when we update sidebar
// const ChangeEligibilityIcon = (): JSX.Element => {
//   return <ChangeEligibility width='100%' className={`${getHeight(true)}`} />;
// };

export const VoucherIcon = (): JSX.Element => {
  return <Voucher />;
};

export const VoidCodeIcon = (): JSX.Element => {
  return <VoidCode />;
};

export const VoidLineIcon = (): JSX.Element => {
  return <VoidLine />;
};

export const VoidItemIcon = (): JSX.Element => {
  return <VoidItem />;
};

export const RepeatIcon = (): JSX.Element => {
  return <Repeat />;
};

export const PriceOverrideIcon = (): JSX.Element => {
  return <PriceOverride />;
};
// this will be implemented either when needed again or when we update sidebar
// const TareWeightIcon = (): JSX.Element => {
//   return <TareWeight width='100%' className={`${getHeight(true)}`} />;
// };
export const ReprintReceiptIcon = (): JSX.Element => {
  return <Print />;
};

export const SaveTransactionIcon = (): JSX.Element => {
  return <SaveTransaction />;
};

export const ScanAndGoIcon = (): JSX.Element => {
  return <ScanAndGo />;
};

export const DepartmentSaleIcon = (): JSX.Element => {
  return <DepartmentSale />;
};
export const MergeTransactionIcon = (): JSX.Element => {
  return <MergeTransaction />;
};
export const RemoveCustomerIcon = (): JSX.Element => {
  return <PersonRemove />;
};
export const ReturnItemIcon = (): JSX.Element => {
  return <ReturnItem />;
};
export const PriceCheckIcon = (): JSX.Element => {
  return <PriceCheck />;
};
export const TaxExemptionIcon = (): JSX.Element => {
  return <TaxExemption />;
};

export const ReloadItemIcon = (): JSX.Element => {
  return <ReloadItem />;
};

export const SaleModeIcon = (): JSX.Element => {
  return <SaleMode />;
};

export const BalanceInquiryIcon = (): JSX.Element => {
  return <OnlineItemBalanceInquiry />;
};

export const DepartmentReturnIcon = (): JSX.Element => {
  return <DepartmentReturn />;
};

export const CashIcon = (): JSX.Element => {
  return <Cash />;
};

export const TenderExchangeIcon = (): JSX.Element => {
  return <TenderExchange />;
};

export const OwnBagIcon = (): JSX.Element => {
  return <OwnBag />;
};
